export default "__VITE_ASSET__cVxpYTUf__"